import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Popover from "@material-ui/core/Popover";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const Client = ({
  onChange,
  disabled,
  error,
  title,
  client_data,
  contracts,
  authorization_matrices,
  policies,
  client_structures,
  has_circulation,
  is_fleet_owner,
  vehicle_state,
  ...props
}) => {
  const handleChange = event => {
    onChange(event, "client_data");
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpenPopover = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const formatDate = date => {
    //hansa_start_date = '2019-12-31'
    //return newDate[2]
    if (date == null || date === "") {
      return null;
    } else {
      if (date.includes("-")) {
        var dateParts = date.split("-");
        var day = dateParts[2];
        var month = parseInt(dateParts[1]);
        month = month < 10 ? "0" + month : month;
        var year = dateParts[0];
        return year + "-" + month + "-" + day;
      } else {
        var dateParts = date.split("/");
        var year = dateParts[2];
        var month = parseInt(dateParts[1]);
        month = month < 10 ? "0" + month : month;
        var day = dateParts[0];
        return year + "-" + month + "-" + day;
      }
    }
  };

  const classes = useStyles();

  var disabled_ac_fields = true;
  if (!disabled) {
    disabled_ac_fields = false;
  }

  if (is_fleet_owner === 1 || is_fleet_owner === "1") {
    disabled = true;
  }

  var contract = contracts.filter(
    contract => parseInt(contract.id) === parseInt(client_data.contract_id)
  )[0];
  var hansa_start_date_in_contract = true;
  var hansa_end_date_in_contract = true;
  if (contract && vehicle_state.name === "BAJA GESTION FLOTAS") {
    hansa_start_date_in_contract = client_data.hansa_start_date
      ? client_data.hansa_start_date >= formatDate(contract.hansa_start_date)
        ? true
        : false
      : false;
    hansa_end_date_in_contract = client_data.hansa_end_date
      ? client_data.hansa_end_date <= formatDate(contract.hansa_end_date)
        ? true
        : false
      : false;
  }
  if (contract) {
    hansa_start_date_in_contract =
      client_data.hansa_start_date >= formatDate(contract.hansa_start_date)
        ? true
        : false;
  }

  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="contract_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Contrato
        </InputLabel>
        <Select
          native
          name="contract_id"
          inputProps={{
            name: "contract_id",
            className: "contract_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && client_data.contract_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={client_data.contract_id}
          input={<Input id="grouped-native-select" name="contract_id" />}
        >
          <option value="" />
          {contracts.map(contract => (
            <option id={contract.id} value={contract.id}>
              {contract.name}
            </option>
          ))}
        </Select>
        {error !== "" && client_data.contract_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="authorization_matrix_id"
      >
        Matriz de autorización
        <Select
          native
          name="authorization_matrix_id"
          inputProps={{
            name: "authorization_matrix_id",
            className: "authorization_matrix_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled_ac_fields}
          onChange={handleChange}
          required
          error={
            error !== "" && client_data.authorization_matrix_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={client_data.authorization_matrix_id}
          input={
            <Input id="grouped-native-select" name="authorization_matrix_id" />
          }
        >
          <option value="" />
          {authorization_matrices.map(authorization_matrix => (
            <option
              id={authorization_matrix.id}
              value={authorization_matrix.id}
            >
              {authorization_matrix.name}
            </option>
          ))}
        </Select>
        {error !== "" && client_data.authorization_matrix_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="policy_id"
      >
        Politica de flota
        <Select
          native
          name="policy_id"
          inputProps={{
            name: "policy_id",
            className: "policy_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled_ac_fields}
          onChange={handleChange}
          required
          error={
            error !== "" && client_data.policy_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={client_data.policy_id}
          input={<Input id="grouped-native-select" name="policy_id" />}
        >
          <option value="" />
          {policies.map(policy => (
            <option id={policy.id} value={policy.id}>
              {policy.name}
            </option>
          ))}
        </Select>
        {error !== "" && client_data.policy_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <TextField
        id="hansa_start_date"
        name="hansa_start_date"
        label="Fecha de inicio"
        disabled={disabled}
        //        error={(error !=='' && parseInt(is_fleet_owner) !== 1 && (client_data.hansa_start_date ==='' || client_data.hansa_start_date === null )) ? 'Debe completar este campo' :  false }
        //        helperText= {(error !=='' && parseInt(is_fleet_owner) !== 1 && (client_data.hansa_start_date ==='' || client_data.hansa_start_date === null )) ? 'Debe completar este valor' : ''}
        error={
          error !== "" &&
          parseInt(is_fleet_owner) !== 1 &&
          !hansa_start_date_in_contract
            ? "Debe completar este campo y ser mayor o igual que la fecha del contrato"
            : false
        }
        helperText={
          error !== "" &&
          parseInt(is_fleet_owner) !== 1 &&
          !hansa_start_date_in_contract
            ? "Debe completar este campo y ser mayor o igual que la fecha del contrato"
            : ""
        }
        type="date"
        placeholder="Ingrese la fecha de inicio"
        onChange={handleChange}
        value={client_data.hansa_start_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="hansa_end_date"
        name="hansa_end_date"
        label="Fecha fin"
        disabled={disabled}
        //        error={(error !=='' && (!hansa_end_date_in_contract || (client_data.hansa_end_date ==='' || client_data.hansa_end_date ===null)) || client_data.hansa_start_date > client_data.hansa_end_date ) ? 'La debe superior a la fecha de inicio y dentro del contrato' :  false }
        //        helperText= {(error !=='' && (!hansa_end_date_in_contract || (client_data.hansa_end_date ==='' || client_data.hansa_end_date ===null)) || client_data.hansa_start_date > client_data.hansa_end_date) ? 'La debe superior a la fecha de inicio y dentro del contrato' : ''}
        error={
          error !== "" &&
          parseInt(is_fleet_owner) !== 1 &&
          !hansa_end_date_in_contract
            ? "La fecha debe superior a la fecha de inicio y dentro del contrato"
            : false
        }
        helperText={
          error !== "" &&
          parseInt(is_fleet_owner) !== 1 &&
          !hansa_end_date_in_contract
            ? "La fecha debe superior a la fecha de inicio y dentro del contrato"
            : ""
        }
        type="date"
        placeholder="Ingrese la fecha fin"
        onChange={handleChange}
        value={client_data.hansa_end_date}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <Typography className={contract ? "d-block" : "d-none"} variant="caption">
        Ver fechas contrato
        <VisibilityIcon onClick={handleOpenPopover} />
      </Typography>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Typography className="p-2">
          <div className="">
            <TextField
              id="contract_start_date"
              name="contract_start_date"
              type="date"
              value={contract ? contract.hansa_start_date : ""}
              margin="normal"
              className="mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Fecha desde</Typography>
                  </InputAdornment>
                )
              }}
            />
          </div>
          <div className="">
            <TextField
              id="contract_end_date"
              name="contract_end_date"
              type="date"
              value={contract ? contract.hansa_end_date : ""}
              margin="normal"
              className="mr-2 mt-0"
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Typography variant="caption">Fecha hasta</Typography>
                  </InputAdornment>
                )
              }}
            />
          </div>
        </Typography>
      </Popover>

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="client_structure_id"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Estructura
        </InputLabel>
        <Select
          native
          name="client_structure_id"
          inputProps={{
            name: "client_structure_id",
            className: "client_structure_id"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          error={
            error !== "" && client_data.client_structure_id === ""
              ? "Debe completar este campo"
              : false
          }
          value={client_data.client_structure_id}
          input={
            <Input id="grouped-native-select" name="client_structure_id" />
          }
        >
          <option value="" />
          {client_structures.map(client_structure => (
            <option id={client_structure.id} value={client_structure.id}>
              {client_structure.type.name +
                " " +
                client_structure.code +
                client_structure.name}
            </option>
          ))}
        </Select>
        {error !== "" && client_data.client_structure_id === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>

      <TextField
        id="category_client"
        name="category_client"
        label="Categoria cliente"
        disabled={disabled}
        error={
          error !== "" && client_data.category_client === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && client_data.category_client === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        placeholder="Ingrese la categoria del cliente"
        onChange={handleChange}
        value={client_data.category_client}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <TextField
        id="group_category_client"
        name="group_category_client"
        label="Grupo categoria cliente"
        disabled={disabled}
        error={
          error !== "" && client_data.group_category_client === ""
            ? "Debe completar este campo"
            : false
        }
        helperText={
          error !== "" && client_data.group_category_client === ""
            ? "Debe completar este valor"
            : ""
        }
        type="text"
        placeholder="Ingrese el grupo de la categoria del cliente"
        onChange={handleChange}
        value={client_data.group_category_client}
        margin="normal"
        className="mr-2 "
        InputLabelProps={{
          shrink: true
        }}
        inputProps={{ style: { minWidth: 200, fontSize: "0.75rem" } }}
      />

      <FormControl
        className="mt-3 mr-2"
        style={{ minWidth: 150, fontSize: "0.75rem" }}
        name="has_circulation_documents"
      >
        <InputLabel
          htmlFor="grouped-native-select"
          autoWidth="true"
          style={{ minWidth: 150, fontSize: "0.75rem" }}
        >
          Tiene documentación para circular?
        </InputLabel>
        <Select
          native
          name="has_circulation_documents"
          inputProps={{
            name: "has_circulation_documents",
            className: "has_circulation_documents"
          }}
          style={{ minWidth: 150, fontSize: "0.75rem" }}
          disabled={disabled}
          onChange={handleChange}
          required
          error={
            error !== "" && client_data.has_circulation_documents === ""
              ? "Debe completar este campo"
              : false
          }
          value={client_data.has_circulation_documents}
          input={
            <Input
              id="grouped-native-select"
              name="has_circulation_documents"
            />
          }
        >
          <option value="" />
          {has_circulation.map(has_circulation_option => (
            <option
              id={has_circulation_option.id}
              value={has_circulation_option.id}
            >
              {has_circulation_option.name}
            </option>
          ))}
        </Select>
        {error !== "" && client_data.has_circulation_documents === "" && (
          <FormHelperText style={{ color: "red" }}>
            Debe completar este campo
          </FormHelperText>
        )}
      </FormControl>
    </React.Fragment>
  );
};

export default Client;
